import { orderMapper } from "~/assets/js/utils";

export default {
  async fetchAgencyDeployments({ commit, rootGetters }, { vaccineId, requestParams }) {
    const { page, sortBy, orderBy } = requestParams;
    const size = requestParams.size ?? 10;
    const selectedAgency = rootGetters["application/getSelectedAgency"];
    const isInAgency = selectedAgency.agencyId !== undefined;

    let agencyDeployments;
    if (isInAgency) {
      agencyDeployments = await this.$services.vaccine.fetchAgencyDeployments(
        selectedAgency.agencyId,
        vaccineId,
        { size, page, sortBy, orderBy: orderMapper(orderBy) },
      );
    } else {
      agencyDeployments = await this.$services.vaccine.fetchDeployments(vaccineId, {
        size,
        page,
        sortBy,
        orderBy: orderMapper(orderBy),
      });
    }
    agencyDeployments.sortBy = sortBy;
    agencyDeployments.orderBy = orderBy;
    commit("SET_AGENCY_DEPLOYMENTS", { parent: vaccineId, agencyDeployments });
  },

  removeAgencyDeployments({ commit }, vaccineId) {
    commit("REMOVE_AGENCY_DEPLOYMENTS", { parent: vaccineId });
  },

  removeAllAgencyDeployments({ commit }) {
    commit("REMOVE_ALL_AGENCY_DEPLOYMENTS");
  },

  async fetchAgentDeployments({ commit, rootGetters }, { vaccineId, requestParams }) {
    const { page, sortBy, orderBy } = requestParams;
    const size = requestParams.size ?? 10;
    const selectedAgency = rootGetters["application/getSelectedAgency"];

    const agentDeployments = await this.$services.vaccine.fetchAgencyDeployments(
      selectedAgency.agencyId,
      vaccineId,
      { size, page, sortBy, orderBy: orderMapper(orderBy) },
    );
    agentDeployments.sortBy = sortBy;
    agentDeployments.orderBy = orderBy;
    commit("SET_AGENT_DEPLOYMENTS", { parent: vaccineId, agentDeployments });
  },

  removeAgentDeployments({ commit }, vaccineId) {
    commit("REMOVE_AGENT_DEPLOYMENTS", { parent: vaccineId });
  },

  removeAllAgentDeployments({ commit }) {
    commit("REMOVE_ALL_AGENT_DEPLOYMENTS");
  },

  async executeVaccine({ rootGetters, commit }, { vaccineId, agencyId, agentId }) {
    const selectedAgency = rootGetters["application/getSelectedAgency"];
    const isInAgency = selectedAgency.agencyId !== undefined;

    try {
      if (isInAgency) {
        await this.$services.vaccine.applyToAgent(vaccineId, agentId);
        commit("SET_AGENT_DEPLOYMENT_STATUS", { vaccineId, agentIds: [agentId] });
      } else {
        await this.$services.vaccine.applyToAgency(vaccineId, agencyId);
        commit("SET_AGENCY_DEPLOYMENT_STATUS", { vaccineId, agencyIds: [agencyId] });
      }
      this.$feedback.ok("feedback.execute.vaccine.ok");
    } catch (error) {
      this.$feedback.error("feedback.execute.vaccine.error");
    }
  },

  async stopVaccine({ rootGetters, commit }, { vaccineId, agencyId, agentId }) {
    const selectedAgency = rootGetters["application/getSelectedAgency"];
    const isInAgency = selectedAgency.agencyId !== undefined;

    try {
      if (isInAgency) {
        await this.$services.vaccine.stopFromAgent(vaccineId, agentId);
        commit("SET_AGENT_DEPLOYMENT_STATUS", { vaccineId, agentIds: [agentId] });
      } else {
        await this.$services.vaccine.stopFromAgency(vaccineId, agencyId);
        commit("SET_AGENCY_DEPLOYMENT_STATUS", { vaccineId, agencyIds: [agencyId] });
      }
      this.$feedback.ok("feedback.stop.vaccine.ok");
    } catch (error) {
      this.$feedback.error("feedback.stop.vaccine.error");
    }
  },

  async updateAutorun({ rootGetters, commit }, { vaccineId, value }) {
    const { agencyId } = rootGetters["application/getSelectedAgency"];
    const isAdminUser = rootGetters["application/isAdminUser"];

    try {
      const isInAgency = agencyId !== undefined;
      let updatedVaccine;

      if (isInAgency) {
        updatedVaccine = value
          ? await this.$services.vaccine.applyToAgency(vaccineId, agencyId)
          : await this.$services.vaccine.stopFromAgency(vaccineId, agencyId);
        commit("SET_VACCINE_STATUS_AUTORUN", { vaccineId, value });
      } else if (!isAdminUser) {
        updatedVaccine = value
          ? await this.$services.vaccine.applyToUserAgencies(vaccineId)
          : await this.$services.vaccine.stopFromUserAgencies(vaccineId);
        commit("SET_VACCINE_STATUS_AUTORUN", { vaccineId, value });
      } else {
        updatedVaccine = await this.$services.vaccine.patch(vaccineId, { autorun: value });
      }

      commit("SET_VACCINE", updatedVaccine);
      if (isInAgency) {
        commit("SET_AGENT_DEPLOYMENT_STATUS_AUTORUN", { parent: vaccineId, value });
      } else {
        commit("SET_AGENCY_DEPLOYMENT_STATUS_AUTORUN", { parent: vaccineId, value });
      }

      const text = value
        ? "feedback.selfexecute.activate.vaccine.ok"
        : "feedback.selfexecute.deactivate.vaccine.ok";
      this.$feedback.ok(text);
    } catch (error) {
      const text = value
        ? "feedback.selfexecute.activate.vaccine.error"
        : "feedback.selfexecute.deactivate.vaccine.error";
      this.$feedback.error(text);
      throw error;
    }
  },
};
